import React, { useState, useEffect } from "react";
import { Modal  } from "react-bootstrap";
import { Box, Typography ,CardMedia,Dialog,Button} from "@mui/material";
import deleteIcon from '../../../assets/DeleteIcon.png'
import shareIcon from '../../../assets/shareIcon.png'
import CloseIcon from "@mui/icons-material/Close";



const DeleteAndShareModal = ({ show, handleClose,showModal,position }) => {
  const theme = localStorage.getItem("theme");
  const [link, setLink] = useState("");
  const [toggleLogout , setToggleLogout] = useState(false)
  const publicLink = "https://www.modalx/public_link/thread_122";
  const [copied, setCopied] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false); // State to toggle more options


  const closefun = () => {
    setToggleLogout(false);
  };

  const showDeleteModal = () =>{
    setToggleLogout(true)
  }
  console.log(showModal)

  return (
  <Box>
          <Box
        sx={{
            display: showModal ? 'block' : 'none',
            width: "160px",
            // height: "116px",
            bgcolor: "#282D51",
            borderRadius: "4px",
            // paddingLeft: "4px",
            position: "sticky",
            marginBottom : '-150px',
            // top : '100px',
            // // marginTop : '10px',
            marginLeft : '30px',
            zIndex : 100,
            overflow : 'visible',
  
        }}
      > 
        <Box
        onClick={showDeleteModal}
          sx={{
            marginTop: "8px",
            width: "100%",
            height: "48px",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            '&:hover': {
              cursor: 'pointer',
            },
           
          }}
        >
          <Box
          
            sx={{
              width: "16px",
              height: "16px",
            }}
          >
        <CardMedia
        component="img"
        alt="Image description"
        
        image={deleteIcon}
      />
          </Box>

          <Box
            sx={{
              width: "100px",
              height: "20px",
            }}
          >

            <Typography sx={{
                fontFamily : 'Inter',
                fontSize : '14px',
                fontWeight : 400,
                lineHeight : '20px',
                letterSpacing : '0.1px',
                textAlign : 'left',
                color : '#FFFFFF',

            }}>Delete project</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginTop: "-10px",
            width: "192px",
            height: "48px",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            '&:hover' :{
              cursor : "pointer"
            }
          }}
        >
          <Box
            sx={{
              width: "16px",
              height: "16px",
            }}
          >
        <CardMedia
        component="img"
        alt="Image description"
        
        image={shareIcon}
      />
          </Box>

          <Box
            sx={{
              width: "132px",
              height: "20px",
            }}
          >

            <Typography sx={{
                fontFamily : 'Inter',
                fontSize : '14px',
                fontWeight : 400,
                lineHeight : '20px',
                letterSpacing : '0.1px',
                textAlign : 'left',
                color : '#FFFFFF',

            }}>Share project</Typography>
          </Box>
        </Box>
      </Box>
      <Dialog
          open={toggleLogout}
          close={closefun}
          PaperProps={{
            sx: {
              width: "100%", // Increase the width as needed
              borderRadius: "8px", // Adjust if you want to change the border radius
            },
          }}
        >
          <Box
            sx={{
              width: "600px",
              height: "200px",
              borderRadius: "8px",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              bgcolor: "#171A2D",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                justifyContent: "center",
                display: "flex",
              }}
            >
              <Box
                sx={{
                  width: "560px",
                  height: "28px",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "20px",
                    fontWeight: 600,
                    lineHeight: "20px",
                    textAlign: "left",
                    color : '#FFFFFF'
                  }}
                >
                  Delete project?
                </Typography>
                <Box  sx={{
                    color : '#FFFFFF',
                    '&:hover' :{
                      cursor : "pointer"
                    }
                }} onClick={closefun}>
                    <CloseIcon/>
                    </Box>
              </Box>
            </Box>

            <Box
              sx={{
                width: "560px",
                height: "20px",

                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "20px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  textAlign: "left",
                  color : '#FFFFFF'
                }}
              >
               You will no longer see this project in the list. This action cannot be undone. Are you sure you want to delete this project?
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "20px",
                width: "580px",
                height: "72px",
                display: "flex",
                justifyContent: "right",
              }}
            >
              <Box
                sx={{
                  width: "226px",
                  height: "40px",
                  marginRight: "16px",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  onClick={closefun}
                  sx={{
                    width: "103px",
                    height: "40px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    bgcolor: "#FFFFFF",
                    color: "#17182C",
                    '&:hover': {
                        backgroundColor: '#CDCFDF'

                      },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  // onClick={handleLogout}
                  sx={{
                    width: "103px",
                    height: "40px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 600,
                    textAlign: "center",
                    bgcolor: "#DD2025",
                    color: "#FFFFFF",
                    '&:hover': {
                        backgroundColor: '#E6E0E91F'

                      },
                  }}
                >
                  Delete
                </Button>
              </Box>
            </Box>
          </Box>
        </Dialog>
      

  </Box>

   
  );
};

export default DeleteAndShareModal;
